export default __webpack_public_path__ + "static/media/IMG9614.ebdeffed.jpg";